// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Conditions_wrapper__O-Vfh {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border: 1px solid;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px 20px;
  margin-top: 20px;
}
.Conditions_title__J0XEz {
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.016px;
}
.Conditions_list__Kb4A1 {
  padding: 32px;
  font-size: 14px;
  line-height: normal;
  border: 1px solid;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  margin-top: 0px;
}
.Conditions_title__J0XEz,
.Conditions_list__Kb4A1 {
  font-family: Inter;
  font-style: normal;
  color: #5f6d7e;
}
`, "",{"version":3,"sources":["webpack://./src/components/Conditions/Conditions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  border: 1px solid;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  padding: 10px 20px;\n  margin-top: 20px;\n}\n.title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  text-align: center;\n  letter-spacing: -0.016px;\n}\n.list {\n  padding: 32px;\n  font-size: 14px;\n  line-height: normal;\n  border: 1px solid;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  margin-top: 0px;\n}\n.title,\n.list {\n  font-family: Inter;\n  font-style: normal;\n  color: #5f6d7e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Conditions_wrapper__O-Vfh`,
	"title": `Conditions_title__J0XEz`,
	"list": `Conditions_list__Kb4A1`
};
export default ___CSS_LOADER_EXPORT___;
